/**
 * Shared helpers for hero slider image fitting.
 *
 * fit values:
 *   'cover'   -> "Doldur (kırp)"      : image fills the hero, may crop edges
 *   'contain' -> "Tümünü göster"      : whole image shown, fits width (no crop)
 *   null/undefined (legacy sliders)   -> responsive default: full image on mobile,
 *                                        cover on desktop (keeps existing look)
 */

export function heroImgClass(fit) {
  if (fit === 'cover') return 'w-full h-full object-cover';
  if (fit === 'contain') return 'w-full h-auto object-contain';
  return 'w-full h-auto object-contain md:h-full md:object-cover';
}

export function heroWrapperClass(fit) {
  if (fit === 'cover') return 'absolute inset-0';
  if (fit === 'contain') return 'relative';
  return 'relative md:absolute md:inset-0';
}

/**
 * Height classes for the hero container.
 * mobileH / desktopH are Tailwind classes, e.g. 'h-[60vh]' and 'md:h-[80vh]'.
 */
export function heroHeightClass(fit, mobileH, desktopH) {
  if (fit === 'cover') return `${mobileH} ${desktopH}`;
  if (fit === 'contain') return '';          // auto height -> fits full image
  return desktopH;                            // responsive default: auto on mobile, fixed on desktop
}
